import React, { FC, PropsWithChildren } from "react";

import { unitPageLayoutContent } from "@components/UnitPageLayout/styles";

import { unitLayoutContentContainerId } from "@views/Unit/constants";

const Content: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div css={unitPageLayoutContent} id={unitLayoutContentContainerId}>
      {children}
    </div>
  );
};

export default Content;
